export default __webpack_public_path__ + "static/media/header desc.da1c3ee7.png";